import React, { useState, useEffect } from "react";
import { Popconfirm, Icon, Card, Row, Col, Tag, Tooltip } from "antd";
import moment from "moment";
//import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

// Components
import ThreeFigure from "../../components/three-figure";
import Table from "../../components/table";
import Search from "../../components/table/search";
import SearchDates from "../../components/table/searchDates";
import RenderFigureData from "../../components/render-figure-data";

import Colors from "../../theme/colors";

// pages
import Articulo from "../articulo";

// Hooks
import useDesings from "../../hooks/useDesings";

// Styles
import { ThreeBox } from "./styles";

//import multilanguage library
import { useTranslation } from 'react-i18next'

const ListArticles = ({ changeTitle }) => {
  const [listOfArticles, setListOfArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState([]);

  const [edit, setEdit] = useState(false);
  const [editDesingEl, setEditDesingEl] = useState({});

  const { desings, getArticlesWithDesings } = useDesings();

  const dispath = useDispatch();

  //To translate text
  const { t } = useTranslation();

  //const history = useHistory();

  //hange title
  useEffect(() => {
    changeTitle && !edit && changeTitle("articles");
  }, [changeTitle, edit]);

  useEffect(() => {
    const normalized = desings.map(article => {
      return {
        key: article.id,
        inUse: getArticlesWithDesings().includes(article.id),
        ...article
      };
    });

    normalized && setListOfArticles(normalized);
    if (normalized && normalized[0]) {
      setSelectedArticle(normalized[0]);
      setSelectedRowKey([normalized[0].key]);
    }
  }, [desings]);

  const editDesing = record => {
    const des = {
      id: record.id,
      articleName: record.articleName,
      isPrototype: record.isPrototype,
      grade: record.grade,
      figure: record.figure,
      selected_figure: record.selected_figure,
      hard_coat: record.hard_coat,
      hardness_required: record.hardness_required,
      type: "update"
    };
    changeTitle("edit_article", record.articleName);
    setEditDesingEl(des);
    setEdit(!edit);
  };

  const deleteArticle = id => {
    const state = {
      id: id
    };
    dispath({ type: "DELETE_DESING", state });
  };

  const cloneDesing = record => {
    const des = {
      id: record.id,
      articleName: "",
      isPrototype: record.isPrototype,
      grade: record.grade,
      figure: record.figure,
      selected_figure: record.selected_figure,
      hard_coat: record.hard_coat,
      hardness_required: record.hardness_required
    };
    changeTitle("clone_article", record.articleName);
    setEditDesingEl(des);
    setEdit(!edit);
  };

  const columns = [
    {
      title: t('table.header.name'),
      dataIndex: "articleName",
      key: "articleName",
      sorter: (a, b) => a.articleName.localeCompare(b.articleName),
      defaultSortOrder: "descend",
      ...Search("articleName")
    },
    {
      title: t('table.header.geometry'),
      dataIndex: "selected_figure",
      key: "selected_figure",
      sorter: (a, b) => a.selected_figure.localeCompare(b.selected_figure),
      //...Search("selected_figure"),
      filters: [
        { text: t('geometry.cylinder'), value: "cylinder" },
        { text: t('geometry.rhomboid'), value: "rhomboid" },
        { text: t('geometry.torus'), value: "torus" },
        { text: t('geometry.rectangle'), value: "rectangle" }
      ],
      onFilter: (value, record) => record.selected_figure.includes(value),
      render: value => t('geometry.'+value)
    },
    {
      title: t('table.header.type'),
      dataIndex: "isPrototype",
      key: "isPrototype",
      width: 100,
      render: isPrototype => (isPrototype ? t('labels.prototype') : t('labels.catalogue')),
      filters: [
        { text: t('labels.prototype'), value: true },
        { text: t('labels.catalogue'), value: false }
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.isPrototype === value
    },
    {
      title: t('table.header.article_date'),
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      ...SearchDates("date"),
      render: date => moment(date).format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: t('table.header.actions'),
      key: "action",
      width: 140,
      render: (text, record) => (
        <Row type="flex" justify="space-between">
          <Tooltip title={t('button.action.clone', { value: record.articleName })}>
            <Icon type="diff" onClick={() => cloneDesing(record)} />
          </Tooltip>
          <Tooltip title={record.inUse ? t('button.action.associated_design') : t('button.action.edit', { value: record.articleName })}>
            <Icon type="edit" onClick={() => !record.inUse && editDesing(record)} style={{ color: record.inUse && "#ccc" }} />
          </Tooltip>
          <Popconfirm
            disabled={record.inUse}
            title={t('button.confirm.delete_article', { value: record.articleName })}
            okText={t('button.confirm.yes')}
            onConfirm={() => deleteArticle(record.id)}
            cancelText={t('button.confirm.no')}
            icon={<Icon type="question-circle-o" style={{ color: Colors.danger }} />}
          >
            <Tooltip title={record.inUse ? t('button.action.associated_design') : t('button.action.delete', { value: record.articleName })}>
              <Icon type="delete" style={{ color: record.inUse ? "#ccc" : Colors.danger }} />
            </Tooltip>
          </Popconfirm>
        </Row>
      )
    }
  ];

  // rowSelection objects indicates the need for row selection
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      setSelectedArticle(desings.find(obj => obj.id === record.id));
    },
    //no existe en type: radio
    onSelectAll: (selected, selectedRows, changeRows) => {
      console.log(selected, selectedRows, changeRows);
    },
    type: "radio"
  };

  //const goForward = () => history.goForward();

  const editClose = () => {
    setEdit(false);
    //changeTitle("Artículos");
  };

  const clickRow = row => {
    setSelectedRowKey([row.key]);
    setSelectedArticle(desings.find(obj => obj.id === row.id));
  };

  return edit ? (
    <Articulo desing={editDesingEl} back={true} close={editClose} />
  ) : (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col xl={16} lg={24}>
        <Table data={listOfArticles} columns={columns} rowSelection={rowSelection} onClick={() => clickRow} />
      </Col>
      <Col xl={8} lg={24}>
        <Card
          title={selectedArticle && selectedArticle.articleName}
          extra={selectedArticle && selectedArticle.isPrototype ? <Tag color="magenta">{t('labels.prototype')}</Tag> : <Tag color="blue">{t('labels.catalogue')}</Tag>}
          cover={
            selectedArticle && (
              <ThreeBox>
                <ThreeFigure figureData={selectedArticle && selectedArticle.figure[0]} />
              </ThreeBox>
            )
          }
        >
          <RenderFigureData selectedArticle={selectedArticle} />
        </Card>
      </Col>
    </Row>
  );
};

export default ListArticles;
